import { render, staticRenderFns } from "./DataWrite.vue?vue&type=template&id=7484582a&scoped=true"
import script from "./DataWrite.vue?vue&type=script&lang=js"
export * from "./DataWrite.vue?vue&type=script&lang=js"
import style0 from "./DataWrite.vue?vue&type=style&index=0&id=7484582a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484582a",
  null
  
)

export default component.exports